<div class="layout-sidebar white-nch" *ngIf="!visible" style="
    border-radius: 20px;" [@slideInOut]="{
        value: visible ? 'in' : 'out',
        params: { direction: '-100' }
    }">
    <div class="sidebar-header">
    </div>
    <div #menuContainer class="layout-menu-container">
        <app-menu [userConnected]="userAD" *ngIf="userAD; else loadingMenuContainer"></app-menu>
        <ng-template #loadingMenuContainer>
            <ul class="layout-menu">
                <ng-container *ngFor="let fake of [].constructor(4); let i = index">
                    <li>
                        <p-skeleton size="5rem" styleClass="mb-4"></p-skeleton>
                    </li>
                </ng-container>
            </ul>
        </ng-template>
    </div>
</div>

<style>
    .layout-sidebar {
        position: relative;
    }

    .layout-menu {
        display: flex;
        flex-direction: column;
        align-items: center;
        /* Centre horizontalement */
    }
</style>